import React, { useCallback, useState } from 'react';
import { Typography, Button, Box } from '@material-ui/core';
import { useSelector } from "react-redux";

import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import locales from '../../../locales';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import { IAppStore } from "../../../types/IAppStore";
import { useDeleteMutation } from "../../../entities";

const styles = () => createStyles({
  contentWrap: {
    padding: '20px',
    borderRadius: '6px',
    background: '#F8F9FF',
  },
  button: {
    color: '#fff',
    backgroundColor: '#FF4C51',
    border: '1px solid rgb(220, 0, 78)',
    '&:hover': {
      backgroundColor: '#FF4C51',
      border: '1px solid rgb(220, 0, 78)',
    },
    '&:focus': {
      backgroundColor: '#FF4C51',
      border: '1px solid rgb(220, 0, 78)',
    },
    '&:disabled': {
      backgroundColor: '#FF4C51',
      opacity: '0.45',
      color: '#fff',
    },
  },
  title: {
    marginBottom: '24px'
  },
});

interface IProps extends WithStyles<typeof styles> {
}

const SettingsComponent: React.FC<IProps> = ({ classes }) => {
  const [isChecked, setIsChecked] = useState(false);
  const restaurantId = useSelector((state: IAppStore) => state.cabinet.currentRestaurant?.id);
  const cashbox = useSelector((state: IAppStore) => state.cabinet.cashBoxPlugins);

  const deleteMutation = useDeleteMutation();

  const changeIsChecked = (checked: boolean) => {
    setIsChecked(checked)
  }

  const handleDelete = useCallback(() => {
    if (!restaurantId || !cashbox?.[0]?.hwid) return;
    deleteMutation.mutate({ hwid: cashbox[0].hwid, restaurantId });
  }, [restaurantId, cashbox, deleteMutation]);

  if (!cashbox?.[0]?.hwid) {
    return null;
  }

  return (
    <>
      <div className={classes.contentWrap}>
        <Typography variant="h6" className={classes.title}>
          {locales.t('cashbox.settings.title')}
        </Typography>
        <Box mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={isChecked}
                onChange={(e: any) => {
                  changeIsChecked(e.target.checked)
                }}
                name="accept"
              />}
            label={locales.t('cashbox.settings.description')}
          />
        </Box>
        <Button
          className={classes.button}
          variant="outlined"
          color="secondary"
          onClick={handleDelete}
          disabled={!isChecked}
        >
          {locales.t('cashbox.settings.actions.delete.title')}
        </Button>
      </div>
    </>
  );
}

const Settings = withStyles(styles)(SettingsComponent);

export { Settings };
